import React from 'react';
import { Typography, Tag, Empty, Row, Col } from 'antd';
import { ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import SlotCard from './SlotCard';

const { Text } = Typography;

const SlotList = ({ slots, selectedSlot, onSelect, dateLabel }) => {
  if (!slots || slots.length === 0) {
    return (
      <Empty
        image={<CalendarOutlined style={{ fontSize: 48, color: '#d1d5db' }} />}
        description="Aucun créneau disponible pour cette date"
        style={{ padding: '40px 0' }}
      />
    );
  }

  // Group by time
  const grouped = slots.reduce((acc, slot) => {
    if (!acc[slot.heure]) acc[slot.heure] = [];
    acc[slot.heure].push(slot);
    return acc;
  }, {});

  return (
    <div style={{ padding: '0 4px 16px' }}>
      {dateLabel && (
        <Text type="secondary" style={{ fontWeight: 500, display: 'block', marginBottom: 16 }}>
          Créneaux du {dateLabel}
        </Text>
      )}

      {Object.entries(grouped).map(([time, timeSlots]) => (
        <div key={time} style={{ marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <ClockCircleOutlined style={{ color: '#059669' }} />
            <Text strong style={{ color: '#059669' }}>{time}</Text>
            <Tag color="green" style={{ margin: 0, fontSize: 11 }}>
              {timeSlots.length} dispo
            </Tag>
          </div>

          <Row gutter={[12, 12]}>
            {timeSlots.map((slot, index) => (
              <Col xs={24} sm={12} key={`${slot.equipe_id}-${slot.heure}-${index}`}>
                <SlotCard
                  slot={slot}
                  selected={selectedSlot === slot}
                  onClick={() => onSelect(slot)}
                />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

export default SlotList;
